/**
 * i18n configuration for GRID/CLU frontend.
 * English is the source of truth; Spanish (and future locales) are additive.
 * Persists language in localStorage under key: grid_locale
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from './locales/en/common.json';
import esCommon from './locales/es/common.json';

const STORAGE_KEY = 'grid_locale';

export const supportedLngs = ['en', 'es'] as const;
export type SupportedLng = (typeof supportedLngs)[number];

export function getStoredLanguage(): SupportedLng {
  if (typeof window === 'undefined') return 'en';
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'es' || stored === 'en') return stored;
  return 'en';
}

export function setStoredLanguage(lng: SupportedLng): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(STORAGE_KEY, lng);
}

i18n.use(initReactI18next).init({
  resources: {
    en: { common: enCommon as Record<string, unknown> },
    es: { common: esCommon as Record<string, unknown> },
  },
  defaultNS: 'common',
  lng: getStoredLanguage(),
  fallbackLng: 'en',
  supportedLngs: [...supportedLngs],
  interpolation: {
    escapeValue: false, // React already escapes
  },
  react: {
    useSuspense: false,
  },
});

i18n.on('languageChanged', (lng) => {
  setStoredLanguage(lng as SupportedLng);
});

export default i18n;
